import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pagination"
}
const _hoisted_2 = ["onClick"]

import { onMounted, ref, nextTick, onUnmounted, ComponentPublicInstance, computed } from 'vue';
import { debounce } from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'CarouselPagination',
  props: {
    carouselRef: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const visibleCards = ref<boolean[]>([]);
const hasHiddenCard = computed(() => visibleCards.value.includes(false));

const isElementVisible = (el: HTMLElement) => {
  const rect = el.getBoundingClientRect();
  const parentRect = props.carouselRef?.$el.getBoundingClientRect();

  return (
    rect.top >= parentRect.top
      && rect.left >= parentRect.left
      && rect.bottom <= parentRect.bottom
      && rect.right <= parentRect.right
  );
};

const updVisibleCards = debounce(() => {
  const items: HTMLElement[] = props.carouselRef?.$el.querySelectorAll('.slideEl');
  nextTick(() => {
    visibleCards.value = Array.from(items).map((item) => isElementVisible(item));
  });
}, 100);

const resizeAction = () => {
  updVisibleCards();
};

const findIndex = () => visibleCards.value.findIndex((x: boolean) => x);

const goTo = (index: number, isVisible: boolean) => {
  if (isVisible) { return; }
  const counterActivePoints = visibleCards.value.filter(Boolean).length;
  const currentIndex = findIndex();
  const adjustedIndex = index > currentIndex ? index - counterActivePoints + 1 : index;
  props.carouselRef?.slideTo(adjustedIndex);
};

onMounted(() => {
  updVisibleCards();
  window.addEventListener('resize', resizeAction);
});

onUnmounted(() => {
  window.removeEventListener('resize', resizeAction);
});

__expose({
  updVisibleCards,
  hasHiddenCard,
  visibleCards,
});


return (_ctx: any,_cache: any) => {
  return (hasHiddenCard.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleCards.value, (isVisible, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `pag-${index}`,
            class: _normalizeClass(["pagination-item", { disabled: isVisible }]),
            onClick: ($event: any) => (goTo(index, isVisible))
          }, null, 10, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})